export const EDIT_ONLINE_TRASNFERS = 'EDIT_ONLINE_TRASNFERS';
export const EDIT_OFFLINE_TRASNFERS = 'EDIT_OFFLINE_TRASNFERS';
export const GENERATE_TRANSFERS_KEY = 'generate_transfers';

export const ONLINE_TRANSFERS_CREATE_QUOTE = 'ONLINE_TRANSFERS_CREATE_QUOTE';
export const ONLINE_TRANSFERS_MODAL = 'ONLINE_TRANSFERS_MODAL';
export const SAVE_TRANSFERS = 'SAVE_TRANSFERS';
